const forceHTTPS = (url) => {
  const regex = /^(\/|https?|#|mailto:|tel:)/gm;
  return regex.test(url.toLowerCase()) ? url : `https://${url}`;
};

export default forceHTTPS;
